import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { cn } from 'modules/Common/utils/cn';
import {
  DEFAULT_REGULATION,
  legalSourceUrl,
  splitCitations,
} from 'modules/Common/utils/legalCitations';

export default function CgLegalCitation({ regulation = DEFAULT_REGULATION, children, className }) {
  const { t } = useTranslation();
  const url = legalSourceUrl(regulation);
  if (!url) return <>{children}</>;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener"
      className={cn(
        'text-primaryColor underline decoration-primaryColor/40 underline-offset-2 hover:decoration-primaryColor',
        className,
      )}
    >
      {children}
      <FontAwesomeIcon
        icon={faArrowUpRightFromSquare}
        className="ml-0.5 inline-block h-2.5 w-2.5 align-baseline"
        aria-hidden
      />
      <span className="sr-only">
        {' '}
        {t('common:legalCitation.opensInNewTab', '(opens in a new tab)')}
      </span>
    </a>
  );
}

export function CgCitedText({ text, bare = false, linkClassName }) {
  if (typeof text !== 'string' || text === '') return text ?? null;
  return (
    <>
      {splitCitations(text, { bare }).map((part, i) =>
        part.type === 'cite' ? (
          <CgLegalCitation
            key={i}
            regulation={part.regulation}
            className={linkClassName}
          >
            {part.value}
          </CgLegalCitation>
        ) : (
          <React.Fragment key={i}>{part.value}</React.Fragment>
        ),
      )}
    </>
  );
}

export { LEGAL_SOURCES, legalSourceUrl } from 'modules/Common/utils/legalCitations';
